import actions from './actions'

export default function InventoryLogsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVENTORYLOG:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVENTORYLOG:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVENTORYLOG2:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESETLIST_INVENTORYLOG:
      return {
        ...state,
        editing: null,
        result: null,
        loading: false,
      }
    case actions.NEW_INVENTORYLOG:
      return {
        ...state,
        editing: { inventoryLogID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVENTORYLOG_RECIEVED ||
      actions.UPDATE_INVENTORYLOG_RECIEVED ||
      actions.DELETE_INVENTORYLOG_RECIEVED:
      return {
        ...state,
        editing: { inventoryLogID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
